import React from 'react';
import { AnimatePresence } from 'framer-motion';
import Toast, { ToastType } from './toast';
import { observer } from 'mobx-react-lite';
import toastStore from '../../store/toast-store';

const ToastContainer: React.FC = observer(() => {
  
  return (
    <div className="fixed bottom-4 sm:top-4 left-1/2 transform -translate-x-1/2 sm:left-auto sm:right-4 sm:transform-none z-50 flex flex-col gap-2 w-[95%] sm:w-auto">
      <AnimatePresence>
        {toastStore.toasts.map((toast: { id: string; type: ToastType; message: string; duration?: number }) => (
          <Toast
            key={toast.id}
            id={toast.id}
            type={toast.type}
            message={toast.message}
            duration={toast.duration}
            onClose={(id) => toastStore.removeToast(id)}
          />
        ))}
      </AnimatePresence>
    </div>
  );
});

export default ToastContainer;
